import NotificationList from '../components/NotificationList';
import '../styles.scss';

export function NotificationHomePage() {
  return <NotificationList />;
}

export default NotificationHomePage;
